<template>
  <div>
    <div class="page-title">Dashboard</div>
    <div class="dashboard-box">
      <el-tabs v-model="activeName">
        <el-tab-pane label="Open" name="first"></el-tab-pane>
        <el-tab-pane label="In Progress" name="second"></el-tab-pane>
      </el-tabs>
      <template v-if="activeName == 'first'">
      <template v-for="(item,index) in chartData" >
          <el-row type="flex" :gutter="20" :key="index" v-if="index % 2 == 0" class="row-first">
            <el-col :span="12"  v-for="(i,k) in chartData.slice(index, index + 2)" :key="k"><charts :parentData="i"></charts></el-col>
          </el-row>
      </template>
     
      </template>
      <template v-if="activeName == 'second'">
          <progress-item v-for="(item,index) in chartData" :item="item" :key="index"></progress-item>
      </template>
    </div>
  </div>
</template>

<script>
import {getApplicationFormReports} from '@/api/admin/application';
import charts from "./components/charts";
import ProgressItem from './components/progressItem.vue';
export default {
  components: {
    charts,
    ProgressItem,
  },
  data() {
    return {
      activeName:'first',
      status:0,
      chartData: [],
    };
  },
  watch:{
    activeName:{
      handler(newVal){
        if(newVal == 'first'){
           this.status = 0;
        }else if(newVal == 'second'){
          this.status = 1;
        }
        this.getApplicationFormReports();
      },
      deep:true,
      immediate:true
    }
  },
  methods:{
    getApplicationFormReports(){
      let from ={
        status: this.status
      }
      getApplicationFormReports(from).then(res=>{
         this.chartData = res.data.map((item)=>{
              item.list.map((i,b)=>{
                    if(b == 0){
                      i.itemStyle = { color: "rgba(205, 117, 99, 1)" }
                    }else if(b == 1){
                      i.itemStyle = { color: "rgba(224, 175, 91, 1)" }
                    }else if(b == 2){
                      i.itemStyle = { color: "rgba(163, 143, 235, 1)" }
                    }else if(b == 3){
                      i.itemStyle = { color: "rgba(78, 181, 124, 1)" }
                    }
                    return i
              })
           return item
         });
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.dashboard-box {
  padding: 0 20px;
  padding-top: 10px;
  padding-bottom: 40px;
  background-color: #fff;
}
.row-first{
  margin-bottom: 20px;
}
</style>